export default {
  name: 'marking--serialNumType',
};